import http from "./HttpService";

const apiEndpoint = "/wiedervorlage";

export const getWiedervorlagenEndpoint = apiEndpoint + "/";

export function deleteWiedervorlage(wiedervorlageId) {
    return http.delete(apiEndpoint + "/" + wiedervorlageId);
}

export function deleteWiedervorlageEndpoint(wiedervorlageId) {
    return apiEndpoint + "/" + wiedervorlageId;
}
